<template>
  <div class="user-bg">
    <router-link to="/"><img class="user-logo" src="../../assets/img/logo.png"></router-link>
    <div class="user-container">
      <div class="form-container">
        <h3>{{$t("login.title")}}</h3>
        <div class="user-form">
          <el-form :model="loginForm" status-icon :rules="loginRule" ref="loginForm">
            <el-form-item prop="user" :label="$t('login.user')">
              <el-input type="user" v-model="loginForm.user" @keyup.enter.native="submitForm"></el-input>
            </el-form-item>
            <el-form-item prop="password" :label="$t('login.password')">
              <el-input v-model="loginForm.password" type="password" @keyup.enter.native="submitForm"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm" class="submitBtn">{{$t("login.login")}}</el-button>
              <recaptcha ref="recaptcha" @verify="submit"></recaptcha>
            </el-form-item>
          </el-form>
          <router-link to="/forgotpassword" class="go-fgtpwd">{{$t("login.forgotPwd")}}</router-link>
        </div>
      </div>
      <div class="signUp">
        <p>{{$t("login.notMember")}}
          <router-link to="/register" class="go-regi">{{$t("login.signup")}}</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { doLogin } from "../../request";
import Recaptcha from '../Recaptcha'
import { getCookie } from "../../common/utils";
const validator = require("validator");
import { pattern } from "../../../server/common/data";

export default {
  name: "login",
  components: {
    Recaptcha
  },
  data() {
    var validateUser = (rule, value, cb) => {
      if (value === "") {
        cb(new Error(this.$t('login.emailNameRequired')));
      } else if (pattern.username.test(value) || validator.isEmail(value)) {
        cb();
      } else {
        cb(new Error(this.$t('login.emailNameFormat')));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('common.passwordRequried')));
      } else {
        if (pattern.password.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t('common.passwordFormat')));
        }
      }
    };
    return {
      loginForm: {
        user: "",
        password: ""
      },
      loginRule: {
        user: [
          { validator: validateUser, trigger: "blur" }
        ],
        password: [
          { validator: validatePass, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          if (getCookie("test_token")) {
            this.submit(""); // skip google reCaptcha at test 
          } else {
            this.$refs.recaptcha.execute();
          } 
        } else {
          return false;
        }
      });
    },
    submit (token) {
      let data = {password: this.loginForm.password, recaptcha_token: token};
      if (validator.isEmail(this.loginForm.user)) {
        data.email = this.loginForm.user;
      } else {
        data.username = this.loginForm.user;
      }
      doLogin(this, data);
    }
  }
};
</script>

<style lang="scss">
.el-form-item.is-required .el-form-item__label:before {
  content: "";
  margin-right: 0px;
}
.go-fgtpwd {
  width: 100%;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  text-decoration: none;
}
.go-fgtpwd:hover{
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// Login.vue?7495bd3c